module.exports = __webpack_public_path__ + "static/img/videoPoster-old.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/NotaryDetail/videoPoster-old.png
// module id = ubFu
// module chunks = 1